/*
__/\\\\\\\\\\\\\\\__/\\\\\\\\\\\\\\\_____/\\\\\\\\\____        
 _\///////\\\/////__\///////\\\/////____/\\\\\\\\\\\\\__       
  _______\/\\\_____________\/\\\________/\\\/////////\\\_      
   _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_     
    _______\/\\\_____________\/\\\_______\/\\\\\\\\\\\\\\\_    
     _______\/\\\_____________\/\\\_______\/\\\/////////\\\_   
      _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_  
       _______\/\\\_____________\/\\\_______\/\\\_______\/\\\_ 
        _______\///______________\///________\///________\///__
            
            COPYRIGHT TACTICAL TRANSPORTATION ADVISORS, INC. 
            ALL RIGHTS RESERVED.
*/

import { getResponse, getToken } from "./serviceTools";

export async function getDashboard() {
  const data = {
    type: "dashboard",
    target: "get",
    authToken: getToken(),
  };

  const response = await getResponse(data);
  return response;
}

export async function dismissDocumentRequest(uid) {
  const data = {
    type: "dashboard",
    target: "dismissDocumentRequest",
    authToken: getToken(),
    uid: uid,
  };

  const response = await getResponse(data);
  return response;
}

///////////////////////////
/// NEW DASHBOARD FUNCTIONS
///////////////////////////

export async function getDashboardOnboarding() {
  const data = {
    type: "dashboard",
    target: "getOnboarding",
    authToken: getToken(),
  };

  const response = await getResponse(data);
  return response;
}

export async function dismissDocumentRequestOnboarding(uid) {
  const data = {
    type: "dashboard",
    target: "dismissDocumentRequestOnboarding",
    authToken: getToken(),
    uid: uid,
  };

  const response = await getResponse(data);
  return response;
}

export async function getPaychexWorkerDocumentRequestData(documentRequestId) {
  const data = {
    type: "dashboard",
    target: "getPaychexWorkerDocumentRequestData",
    authToken: getToken(),
    documentRequestId: documentRequestId,
  };

  return await getResponse(data);
}

export async function getHistorical({ page, pageSize, filterType, filterValue, dateFrom, dateTo }) {
  const data = {
    type: "dashboard",
    target: "getHistorical",
    authToken: getToken(),
    page,
    pageSize,
    filterType,
    filterValue,
    dateFrom,
    dateTo,
  };
  return await getResponse(data);
}

export async function getHistoricalOnboarding({ page, pageSize, filterType, filterValue, dateFrom, dateTo, excludedCompanyIdentifiers, pendingEVerify, pendingPaychex }) {
  const data = {
    type: "dashboard",
    target: "getHistoricalOnboarding",
    authToken: getToken(),
    page,
    pageSize,
    filterType,
    filterValue,
    dateFrom,
    dateTo,
    excludedCompanyIdentifiers,
    pendingEVerify: pendingEVerify || null,
    pendingPaychex: pendingPaychex || null,
  };
  return await getResponse(data);
}

export async function submitPaychexWorkerDocumentRequestData(dataPayload) {
  const data = {
    type: "dashboard",
    target: "submitPaychexWorkerDocumentRequestData",
    authToken: getToken(),
    ...dataPayload,
  };

  return await getResponse(data);
}

export async function setEVerify(tcCompanyUserIdentifier, eVerify, base64) {
  const data = {
    type: "dashboard",
    target: "setEVerify",
    authToken: getToken(),
    tcCompanyUserIdentifier,
    eVerify,
    base64,
  };
  return await getResponse(data);
}
